import "globals";

(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function () {
        const sliderMapping = [];

        if ($.prototype.slick) {
            // turn dots into numbers
            const slickSlider = $(".slider__items");

            for (let i = 0; i < slickSlider.length; i++) {
                const slider = slickSlider[i];
                const sliderConfig = { slider };

                sliderMapping[i] = sliderConfig;

                const lazyLoad = new LazyLoad({
                    container: slider,
                    elements_selector: '.img-fluid',
                    threshold: 200
                });

                $(slider).slick({
                    customPaging: function (slider, i) {
                        const number = i + 1;
                        const slideNumber = number.toString().length < 2 ? "0" + number : number;
                        return (
                            '<span class="dot">' +
                            slideNumber +
                            '</span><span data-slick-index="' +
                            i +
                            '" class="progressBar"></span>'
                        );
                    },
                });
                lazyLoad.update();

                $(".slider__items").on("afterChange", function() {
                    lazyLoad.update();
                });

                if (slider.closest(".avency-neos-baseslider-content-slider")) {
                    // this is a base slider
                    // position dots and arrows under the image
                    window.onresize = function () {
                        setProgressbar(i);
                    };

                    // progressbar
                    sliderConfig.percentTime = 0;
                    sliderConfig.tick = null;
                    sliderConfig.progressBarIndex = 0;
                    const autoplaySpeed = slider.slick.options.autoplaySpeed;
                    sliderConfig.speed = autoplaySpeed / 1000;

                    $(slider)
                        .find(".slick-dots .progressBar").each(function (index) {
                            const progress = "<div class='inProgress inProgress" + index + "'></div>";
                            $(this).html(progress);
                        });

                    setProgressbar(i);
                    startProgressbar(i);

                    $(slider)
                        .find(".slick-dots li")
                        .click(function () {
                            clearInterval(sliderConfig.tick);
                            const goToThisIndex = $(this).find(".progressBar").data("slickIndex");
                            $(slider).slick("slickGoTo", goToThisIndex, false);
                            startProgressbar(i);
                        });
                }
            }
            function setProgressbar(sliderIndex) {
                const sliderConfig = sliderMapping[sliderIndex];
                const dots = sliderConfig.slider.querySelector(".slick-dots");
                if (dots) {
                    const dotsContainer = document.createElement("div");
                    dotsContainer.setAttribute("class", "container");
                    dotsContainer.innerHTML = dots.innerHTML;
                    dots.innerHTML = "";
                    dots.appendChild(dotsContainer);
                }
            }

            function startProgressbar(sliderIndex) {
                if (document.querySelector(".neos-backend") == null) {
                    resetProgressbar(sliderIndex);
                    const sliderConfig = sliderMapping[sliderIndex];
                    sliderConfig.percentTime = 0;
                    sliderConfig.tick = setInterval(() => interval(sliderIndex), 10);
                }
            }

            function interval(sliderIndex) {

                const sliderConfig = sliderMapping[sliderIndex];
                if (
                    $(sliderConfig.slider)
                        .find('.slick-track div[data-slick-index="' + sliderConfig.progressBarIndex + '"]')
                        .attr("aria-hidden") === "true"
                ) {
                    sliderConfig.progressBarIndex = $(sliderConfig.slider)
                        .find('.slick-track div[aria-hidden="false"]')
                        .data("slickIndex");
                    startProgressbar(sliderIndex);
                } else {
                    sliderConfig.percentTime += 1 / sliderConfig.speed;
                    $(sliderConfig.slider)
                        .find(".inProgress" + sliderConfig.progressBarIndex).css({
                            width: sliderConfig.percentTime + "%",
                        });
                    $(sliderConfig.slider)
                        .find(".inProgress" + sliderConfig.progressBarIndex)
                        .parent(".progressBar")
                        .css({
                            display: "inline-block",
                        });
                    if (sliderConfig.percentTime >= 100) {
                        $(sliderConfig.slider).slick("slickNext");
                        sliderConfig.progressBarIndex++;
                        if (sliderConfig.progressBarIndex > 1) {
                            sliderConfig.progressBarIndex = 0;
                        }
                        startProgressbar(sliderIndex);
                    }
                }
            }

            function resetProgressbar(sliderIndex) {
                const sliderConfig = sliderMapping[sliderIndex];
                $(sliderConfig.slider)
                    .find(".inProgress").css({
                        width: 0 + "%",
                    });
                $(sliderConfig.slider).find(".inProgress").parent(".progressBar").css({
                    display: "none",
                });
                clearInterval(sliderConfig.tick);
            }

            $(document).on("shown.bs.collapse", function (event) {
                $(event.target)
                    .find(".slider__items.slick-initialized")
                    .each(function () {
                        $(this).slick("setPosition");
                    });
            });
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
